import { ReactNode } from 'react';
import { OptimusTextKey } from './OptimusTextKey';

export interface LocalizationProviderProps {
    children: JSX.Element;
    localizationTexts: LocalizationTexts;
}

export interface ILocalizationContext {
    t: (optimusTextKey: OptimusTextKey, options?: TranslationOptions) => ReactNode;
}

export type LocalizationTexts = Record<OptimusTextKey, ReactNode | ((options?: TranslationOptions) => ReactNode)>;

export interface TranslationOptions {
    items?: string;
}
